<template>
  <pt-gene-report-apply-list class="pt-gene-report-apply-list__withData"></pt-gene-report-apply-list>
</template>

<script>
import PtGeneReportApplyList from './index'
export default {
  name: 'pt-gene-report-apply-list__withData',
  components: {
    'pt-gene-report-apply-list': PtGeneReportApplyList
  }
}
</script>
